import React from "react";
import { useSelector } from "react-redux";
import AppBar from "./../../components/DefaultAppBar";
import PropertyManagementProfile from "./PropertyManagementProfile";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import DocumentLayout from "./../../components/Layouts/DocumentLayout";

export const route = "/property-management";

function PropertyManagementContainer() {
  const propertyManagement = useSelector((state) => state.propertyManagement);

  return (
    <div>
      <AppBar position="static">
        <LocationFilterToolbar noTicketFilter />
      </AppBar>
      <DocumentLayout>
        <PropertyManagementProfile estate={propertyManagement} />
      </DocumentLayout>
    </div>
  );
}

PropertyManagementContainer.route = route;

export default PropertyManagementContainer;
